import { Text } from "@react-pdf/renderer";

const AnswerRecommendation = ({ answer }) => {
  return (
    <Text>
      {answer?.answer?.answer || "--"}
    </Text>
  )
}

export default AnswerRecommendation;